import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import SET_SHARED_ENV from './types';
export default _defineProperty({}, SET_SHARED_ENV, function (state, payload) {
  var currentState = state;
  currentState.payload = payload;
});